import {generateMock} from '@anatine/zod-mock';
import type {AnyZodObject, ZodSchema, ZodTypeAny} from 'zod';
import {z} from 'zod';

// Generate a records of all fields in a Zod schema (not working for nested schemas)
export function getZodFlatSchemaFields(schema: ZodSchema): Record<string, true> {
  const fields: Record<string, true> = {};
  const proxy = new Proxy(fields, {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    get(_, key) {
      if (key === 'then' || typeof key !== 'string') {
        return;
      }
      fields[key] = true;
    },
  });
  schema.safeParse(proxy);
  return fields;
}

export function getSchemaKeys<T>(schema: ZodSchema<T>): string[] {
  return Object.keys((schema as unknown as AnyZodObject).shape);
}

export function getPropertiesPathFromZodSchema(schema: ZodTypeAny, prefix = ''): string[] {
  if (schema instanceof z.ZodObject) {
    const shape = schema.shape;

    return Object.keys(shape).flatMap(key => {
      const nestedPrefix = prefix ? `${prefix}.${key}` : key;

      return getPropertiesPathFromZodSchema(shape[key], nestedPrefix);
    });
  }
  return [prefix];
}

export function generateMockObjectFromSchema<T>(schema: z.ZodSchema, seedData?: Partial<T>): T {
  const mock = generateMock(schema);

  return {
    ...mock,
    ...seedData,
  };
}
